function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-399.862 -128.5)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(399.862 128.5)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(576.795 360.795)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-567.335-357.949v5.512a1.1,1.1,0,0,1-.681,1.017,1.01,1.01,0,0,1-.267.072,1.16,1.16,0,0,1-.171.014h-5.5v-2.2h2.841l-.518-.521-5.084-5.117,1.524-1.532,5.3,5.28.342.339v-2.858Z",
  transform: "translate(-0.085 -0.085)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-533.616-313.92a3.638,3.638,0,0,1-3.634-3.634,3.638,3.638,0,0,1,3.634-3.634,3.638,3.638,0,0,1,3.634,3.634A3.638,3.638,0,0,1-533.616-313.92Zm0-5.062a1.43,1.43,0,0,0-1.429,1.429,1.431,1.431,0,0,0,1.429,1.429,1.431,1.431,0,0,0,1.429-1.429A1.43,1.43,0,0,0-533.616-318.982Z",
  transform: "translate(-30.514 -30.56)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-506.243-353.54h2.858v2.2H-508.9a1.1,1.1,0,0,1-1.017-.681.753.753,0,0,1-.041-.127c-.011-.044-.022-.091-.03-.138a1.163,1.163,0,0,1-.014-.174v-5.5h2.2v2.841l.521-.518,5.117-5.084,1.532,1.524-5.28,5.3Z",
  transform: "translate(-50.254 -0.085)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-500.625-287.157l-1.524,1.532-5.3-5.28-.342-.339v2.858H-510V-293.9a1.1,1.1,0,0,1,.681-1.017.992.992,0,0,1,.265-.072l.022,0,.058-.008c.03,0,.063,0,.094,0h5.5v2.2h-2.841l.518.521Z",
  transform: "translate(-50.254 -49.529)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-567.335-293.881v5.5h-2.2v-2.841l-.521.518-5.117,5.084-1.532-1.524,5.28-5.3.339-.342h-2.858V-295h5.512a1.1,1.1,0,0,1,1.017.681.992.992,0,0,1,.072.265c0,.006,0,.014,0,.022l.008.058C-567.335-293.944-567.335-293.911-567.335-293.881Z",
  transform: "translate(-0.085 -49.529)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2,
  cy: 2,
  r: 2,
  transform: "translate(-565.657 -350.295)"
}))));

var SvgCenter = function SvgCenter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25.916,
    height: 25.64,
    viewBox: "0 0 25.916 25.64",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCenter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/center.5b0b25fb.svg";
export { ForwardRef as ReactComponent };